module.exports = __webpack_public_path__ + "static/media/meter_1.8f112ebd.png";